module.exports = __webpack_public_path__ + "img/phon7.bb3be4c6.png";